(() => {
  const initializeTaxonomy = (taxonomy) => {
    if (!taxonomy || taxonomy.dataset.pdReady === "true") return;

    const categoryButtons = [...taxonomy.querySelectorAll("[data-pd-category]")];
    const subcategoryGroups = [...taxonomy.querySelectorAll("[data-pd-subcategory-group]")];
    const categoryLabel = taxonomy.querySelector("[data-pd-category-label]");
    const subcategoryCount = taxonomy.querySelector("[data-pd-subcategory-count]");

    if (!categoryButtons.length || !subcategoryGroups.length) return;

    const activateCategory = (key) => {
      const selectedGroup = subcategoryGroups.find(
        (group) => group.dataset.pdSubcategoryGroup === key,
      );

      if (!selectedGroup) return;

      categoryButtons.forEach((button) => {
        const selected = button.dataset.pdCategory === key;
        button.classList.toggle("is-selected", selected);
      });

      subcategoryGroups.forEach((group) => {
        group.hidden = group !== selectedGroup;
      });

      if (categoryLabel) {
        categoryLabel.textContent = selectedGroup.dataset.pdCategoryTitle || "selected category";
      }

      if (subcategoryCount) {
        subcategoryCount.textContent = selectedGroup.dataset.pdCount || "";
      }
    };

    activateCategory(taxonomy.dataset.initialCategory || categoryButtons[0].dataset.pdCategory);
    taxonomy.dataset.pdReady = "true";
  };

  const initialize = () => {
    document.querySelectorAll("[data-pd-equipment-taxonomy]").forEach(initializeTaxonomy);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
